import { render, staticRenderFns } from "./FrsFab.vue?vue&type=template&id=4c06292e&scoped=true&lang=html&"
import script from "./FrsFab.vue?vue&type=script&lang=js&"
export * from "./FrsFab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c06292e",
  null
  
)

export default component.exports